// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2XJyt","header":"PatientBlock_header__2G9d0","label":"PatientBlock_label__3iBeQ","option":"PatientBlock_option__25Sn_"};